import { createMachine } from "xstate";
import {
  checkPayment,
  ICheckPaymentResponse,
} from "@nju/data-access-portal-payment";
import { ContractError } from "@nju/result";

interface IContext {
  paymentId?: string;
}

type IEvent = {
  type: "completed" | "failed";
  data: ICheckPaymentResponse;
};

export const checkPaymentMachine = createMachine(
  {
    schema: {
      context: {} as IContext,
      events: {} as IEvent,
    },
    initial: "check",
    states: {
      check: {
        invoke: {
          src: "checkPayment",
          onDone: [
            {
              target: "success",
              cond: "completed",
            },
            {
              target: "error",
              cond: "failed",
            },
            { target: "wait" },
          ],
          onError: "error",
        },
      },
      wait: {
        after: { 5000: "check" },
      },
      success: {
        entry: "onSuccessRedirect",
        type: "final",
      },
      error: {
        type: "final",
      },
    },
  },
  {
    services: {
      checkPayment: async ({ paymentId }) => {
        if (!paymentId) {
          throw new ContractError({
            message: "`paymentId` is missing",
          });
        }
        return (await checkPayment({ paymentId })).unwrap();
      },
    },
    guards: {
      completed: (_, { data }) => {
        return data.status === "COMPLETED";
      },
      failed: (_, { data }) => {
        return ["FAILED", "CANCELLED"].includes(data.status);
      },
    },
  },
);
